import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=3dbd5de4&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=3dbd5de4&prod&lang=scss&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=3dbd5de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd5de4",
  null
  
)

export default component.exports